//const API_BASE_URL = "https://localhost:7187/api"; ////local

 const API_BASE_URL = "https://api.monytorevento.com/api"; //Produccion

   export default API_BASE_URL;
